import React from 'react';

const FORM_PUBLIC_URL = /(?<!href=["'])https:\/\/[^\s<>"']+\/forms\/public\/([A-Za-z0-9]+)/gi;

const escapeHtml = (value: string): string => value
  .replaceAll('&', '&amp;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;');

export const formLinkTitlesFromBindings = (
  forms: Array<{ formPublicId?: string; formTitle?: string }>,
): Map<string, string> => {
  const titles = new Map<string, string>();
  forms.forEach((form) => {
    const publicId = form.formPublicId?.trim();
    const title = form.formTitle?.trim();
    if (publicId && title)
    {
      titles.set(publicId.toLowerCase(), title);
    }
  });
  return titles;
};

export const linkifyFormPublicUrls = (
  value: string,
  titles: ReadonlyMap<string, string>,
): string => value.replace(FORM_PUBLIC_URL, (url, publicId: string) => {
  const title = titles.get(publicId.toLowerCase());
  if (!title)
  {
    return url;
  }

  return `<a href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">${escapeHtml(title)}</a>`;
});

export const FormPublicLinkText: React.FC<{
  content: string;
  titles: ReadonlyMap<string, string>;
}> = ({ content, titles }) => {
  const nodes: React.ReactNode[] = [];
  const pattern = new RegExp(FORM_PUBLIC_URL.source, 'gi');
  let lastIndex = 0;
  let match = pattern.exec(content);

  while (match)
  {
    const url = match[0];
    const publicId = match[1].toLowerCase();
    const title = titles.get(publicId);
    if (match.index > lastIndex)
    {
      nodes.push(content.slice(lastIndex, match.index));
    }

    if (title)
    {
      nodes.push(
        <a
          key={`${match.index}-${publicId}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          title={url}
          className="font-medium underline text-blue-600 [.bg-blue-600_&]:text-white [.bg-blue-700_&]:text-blue-50"
        >
          {title}
        </a>,
      );
    }
    else
    {
      nodes.push(url);
    }

    lastIndex = match.index + url.length;
    match = pattern.exec(content);
  }

  if (lastIndex < content.length)
  {
    nodes.push(content.slice(lastIndex));
  }

  if (nodes.length === 0)
  {
    return null;
  }

  return <>{nodes}</>;
};
